import clsx from "clsx";
import { useTranslation } from "react-i18next";

export default function AdvantageSection() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  const advantages = t("home.advantage.items", {
    returnObjects: true,
  }) as Array<{ title: string; description: string }>;

  return (
    <div className="relative w-full min-h-0 md:h-[780px] bg-white py-10 md:py-[60px] md:pb-[50px] mb-10 md:mb-[90px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5">
        <h2
          data-aos-delay="100"
          data-aos="fade-up"
          className="font-bold text-[#222] text-[26px] md:text-[34px] text-center pb-[16px] md:pb-[20px] leading-tight"
        >
          {t("home.advantage.title")}
        </h2>
        <p data-aos="fade-up" className="text-center text-[#666] text-[15px] md:text-[18px] leading-relaxed px-2">
          {t("home.advantage.subtitle")}
        </p>
        <div
          className="relative min-h-0 md:h-[600px] my-8 md:my-[60px] bg-none md:bg-[url('/images/index11.jpg')] bg-no-repeat bg-left-top"
          data-aos="fade-up"
          data-aos-anchor-placement="top-center"
        >
          <div className="mb-6 overflow-hidden rounded-lg md:hidden">
            <img src="/images/index11.jpg" alt="" className="w-full h-auto object-cover" />
          </div>
          <div
            className={clsx(
              "bg-white relative md:absolute md:right-0 w-full",
              isZh
                ? "md:w-[540px] md:top-[40px] py-2 md:py-[50px] md:px-[40px]"
                : "md:w-[720px] md:top-0 py-2 md:py-[40px] md:pl-[40px]"
            )}
          >
            {advantages.map((item, index) => {
              const delay = (index + 1) * 100;
              const iconIndex = String(index + 11).padStart(2, "0");
              const iconUrl = `images/index${iconIndex}.png`;

              return (
                <div
                  key={index}
                  className={clsx(
                    "relative mb-5 md:mb-[18px] pl-[90px] md:pl-[140px]",
                    isZh ? "py-3 md:py-[15px]" : "py-2.5 md:py-[10px]"
                  )}
                  data-aos-delay={delay}
                  data-aos="fade-up"
                  data-aos-anchor-placement="top-center"
                >
                  <i
                    className="w-[70px] h-[70px] md:w-[100px] md:h-[100px] rounded-full absolute top-[4px] left-0 bg-no-repeat bg-center bg-contain"
                    style={{ backgroundImage: `url(${iconUrl})` }}
                  ></i>
                  <h3 className="text-[18px] md:text-[20px] font-bold text-[#0f5f95] pb-[8px] md:pb-[10px] leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-left text-[14px] md:text-[16px] leading-[22px] md:leading-[24px] text-[#222]">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
